import React, { useState } from 'react'
import {Box, Button, Grid,Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import buttonStyle from '../../../styles/buttonStyle';
import TypeTask from './Type/TypeTask';
import HeaderBox from '../../../components/HeaderBox';
import CashJobType from './Type/CashJobType';
import { CashJob } from '../../../data/CashDate';
import DateCalander from '../../../components/DateCalander';

const FirstCashRow = {
  description: "",
  id: 1,
  qty: "",
  Rate: "",
  amt: "",
  CashJobId: null,
};

function AddCashJob() {
  const navigate = useNavigate();
  const [checked, setChecked] = useState([]);

  const totalamount=() =>{
    const totalCashAmount = rows.reduce((accumulator, row) => {
      return accumulator + parseFloat(row.amt || 0);
  }, 0);
  return totalCashAmount
  }
  const handleToggle = (value, item) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
      addRow(item);
    } else {
      newChecked.splice(currentIndex, 1);
      deleteRow(value);
    }
    setChecked(newChecked);
  };

  const handleDelete = (id) => {
    const currentIndex = checked.indexOf(id);
    const newChecked = [...checked];
    newChecked.splice(currentIndex, 1);
    setChecked(newChecked);
  };

  const [rows, setRows] = useState([]);

  const addRow = (field) => {
    console.log(FirstCashRow.Rate * FirstCashRow.qty);
    const newRow = {
      ...FirstCashRow,
      id: rows.length + 1,
      description: field.label,
      CashJobId: field.id, 
      amt: FirstCashRow.Rate * FirstCashRow.qty}; 
    setRows([...rows, newRow]);
  };

  const deleteRow = (id) => {
    const updatedRows = rows.filter((row) => row.CashJobId !== id);
    const updatedRowsWithConsecutiveIDs = updatedRows.map((row, index) => ({
      ...row,
      id: index + 1,
    }));
    setRows(updatedRowsWithConsecutiveIDs);
  };

  return (
    <Box mt={2}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                {" "}
                CASH JOB
              </Typography>
            </Grid>
            <Grid item xs={6} display="flex" justifyContent="flex-end">
              <Button
                sx={buttonStyle.root}
                onClick={() => navigate("/Add_Cash_Job")}
              >
                {" "}
                Save{" "}
              </Button>
              &nbsp;
              <Button
                sx={buttonStyle.root}
                onClick={() => navigate("/Cash_Job")}
              >
                {" "}
                Cancel{" "}
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} mt={1}>
          <Box>
            <form>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} md={3} p={1}>
                  <HeaderBox title="Type"/>
                      <Paper sx={{ p: 1, mt: 1 }}>
                        <Box
                          sx={{
                            border: "2px solid",
                            borderColor: "rgb(223, 218, 218)",
                            boxShadow: "2px 2px 2px rgba(0, 0, 0, 0.25)",
                          }}
                        >
                          <CashJobType CashJob={CashJob}  handleToggle={handleToggle} checked={checked}/>
                        </Box>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={9} p={1}>
                      <HeaderBox title="CASH JOB CALCULATION" />
                      <Paper sx={{ p: 1, mt: 1 }}>
                      <Grid item xs={12} display="flex" justifyContent="flex-end">
                          <DateCalander  title='Date'/>
                      </Grid>
                        <Box mt={2}>
                          <TypeTask rows={rows} setRows={setRows} addRow={addRow} handleDelete={handleDelete}/>
                        </Box>
                        <Box mt={2}>
                          <Grid container spacing={1}>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                              <Box>
                                <Grid container spacing={1}>
                                  <Grid
                                    item
                                    xs={12}
                                    display="flex"
                                    justifyContent="space-between"
                                    sx={{ borderBottom: "1px solid grey" }}
                                  >
                                    <Typography>Total</Typography>
                                    <Typography>{totalamount()}</Typography>
                                  </Grid>
                                </Grid>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Paper>
                    </Grid>
              </Grid>
            </form>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
export default AddCashJob;
